var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "overlay-modal",
    {
      ref: "overlayModal",
      attrs: { width: "65%" },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("div", { staticClass: "d-md-flex justify-content-between" }, [
                _c(
                  "div",
                  {
                    staticClass: "position-relative",
                    staticStyle: { top: "10px" }
                  },
                  [
                    _c("RatingStars", {
                      staticClass: "position-absolute",
                      staticStyle: { top: "-15px" },
                      attrs: { value: _vm.rating }
                    }),
                    _vm._v(" "),
                    _c("h4", { staticClass: "cursive" }, [
                      _vm._v(_vm._s(_vm.name))
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", [
                  !_vm.isSelected
                    ? _c(
                        "button",
                        {
                          staticClass: "mt-2 mt-md-0 btn btn-primary nowrap",
                          on: { click: _vm.onSelect }
                        },
                        [
                          _vm._v(
                            "\n                    Aggiungi ad itinerario\n                "
                          )
                        ]
                      )
                    : _c(
                        "button",
                        {
                          staticClass: "mt-2 mt-md-0 btn btn-primary nowrap",
                          attrs: { disabled: !_vm.change },
                          on: { click: _vm.onSelect }
                        },
                        [
                          _vm._v(
                            "\n                    Conferma modifiche\n                "
                          )
                        ]
                      )
                ])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      [
        _c("div", { staticClass: "modal-hotel-detail" }, [
          _c(
            "div",
            [
              _vm.images.length > 0
                ? _c("big-carousel", {
                    staticClass: "mb-3",
                    attrs: { images: _vm.images }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "tabs",
                { staticClass: "mb-3" },
                [
                  _c(
                    "tab",
                    { attrs: { width: "25%", title: "Seleziona le camere" } },
                    _vm._l(_vm.groups, function(group, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "mb-3" },
                        [
                          _c("h4", [_vm._v("Camera " + _vm._s(index + 1))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-flex mb-2" }, [
                            _c("img", {
                              staticClass: "mr-2",
                              attrs: {
                                src: require("../../../../../assets/images/svg/black/icone_passeggeri.svg"),
                                height: "18px"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "d-block" }, [
                              _vm._v(_vm._s(_vm.cameraTextFromIndex(index)))
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(group.rooms, function(item, index2) {
                            return _c("room-detail", {
                              key: index2,
                              attrs: { value: item, group: group },
                              on: { change: _vm.onChangeRoomSelected }
                            })
                          })
                        ],
                        2
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "tab",
                    {
                      attrs: { width: "25%", title: "Descrizione" },
                      on: { click: _vm.onSelectTabDescrizione }
                    },
                    [
                      _c("div", [
                        _c("p", {
                          staticClass: "text-justify",
                          domProps: {
                            innerHTML: _vm._s(_vm.toBrTag(_vm.description))
                          }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "tab",
                    { attrs: { width: "25%", title: "Caratteristiche" } },
                    _vm._l(_vm.infos, function(item, index) {
                      return _c("div", { key: index }, [
                        _c("h4", [_vm._v(_vm._s(item.title))]),
                        _vm._v(" "),
                        _c("table", { staticClass: "table table-striped" }, [
                          _c(
                            "tbody",
                            _vm._l(item.paragraphs, function(section, index) {
                              return _c(
                                "tr",
                                { key: index, attrs: { value: section } },
                                [
                                  _c("td", { staticStyle: { width: "30%" } }, [
                                    _c("b", [_vm._v(_vm._s(section.title))])
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticStyle: { width: "70%" } },
                                    _vm._l(section.texts, function(
                                      text,
                                      index
                                    ) {
                                      return _c(
                                        "p",
                                        {
                                          key: index,
                                          staticClass: "m-0",
                                          attrs: { value: text }
                                        },
                                        [_vm._v(_vm._s(text))]
                                      )
                                    }),
                                    0
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "tab",
                    { attrs: { width: "25%", title: "Mappa" } },
                    [
                      _c("CustomGoogleMap", { attrs: { markers: _vm.markers } })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50c5fe2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c5fe2c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/pages/volo-hotel/modals/ModalHotelDetail.vue
// module id = null
// module chunks = 